import { useEffect } from 'react';
import { useI18n } from 'core/i18n/I18nProvider';

export function PageMeta({ titleKey = 'appName' }) {
  const { t } = useI18n();
  useEffect(() => {
    document.title = `${t(titleKey)} · ${t('appName')}`;
  }, [t, titleKey]);
  return null;
}
